import { NotificationLink } from '../../../components/NotificationLink';
import { KText } from '@/ui-library/components';

const MESSAGE_TEMPLATES = {
  RSVP_REMINDER: 'Reminder to RSVP for {interview} with {candidate}',
  REVIEW_REMINDER: 'Reminder: {interview} with {candidate} for {job} in 1 hour',
  STARTING_SOON: 'Starting in {time}: {interview} with {candidate} for {job}',
  MESSAGE_RECEIVED:
    '{interviewer} sent you a message about {interview} with {candidate}',
  INTERVIEW_BOOKED:
    '{interview}  with {candidate} for {job} has been scheduled',
  INTERVIEW_CANCELED:
    '{interview}  with {candidate} for {job} has been canceled',
  INTERVIEW_RESCHEDULED:
    '{interview} with {candidate} for {job} has been updated',
  SCORECARD_REMINDER: "Don't forget to fill out the following scorecard!",
};

export const NotificationMessage = ({
  template,
  data = {},
  onClose = () => {},
  notification = {},
}) => {
  const {
    interview = {},
    candidate = {},
    interviewer = {},
    job = {},
    time,
    // interview_location_enum,
  } = data;

  const renderLink = (type, item) => {
    if (!item?.name) return '';
    if (!item?.url) return item.name;

    return (
      <NotificationLink
        to={item.url}
        label={item.name}
        onClose={onClose}
        notification={notification}
      />
    );
  };

  const renderMessage = () => {
    const templateText = MESSAGE_TEMPLATES[template];
    if (!templateText) return null;

    const parts = templateText.split(/(\{[^}]+\})/g);

    return parts.map((part, index) => {
      if (part.startsWith('{') && part.endsWith('}')) {
        const key = part.slice(1, -1);
        switch (key) {
          case 'interview':
            return (
              <KText key={index} as="span" size="sm-semi-bold">
                {renderLink('interview', interview)}
              </KText>
            );
          case 'candidate':
            return (
              <KText key={index} as="span" size="sm-semi-bold">
                {renderLink('candidate', candidate)}
              </KText>
            );
          case 'interviewer':
            return (
              <KText key={index} as="span" size="sm-semi-bold">
                {renderLink('interviewer', interviewer)}
              </KText>
            );
          case 'job':
            return (
              <KText key={index} as="span" size="sm-semi-bold">
                {renderLink('job', job)}
              </KText>
            );
          case 'time':
            return (
              <KText key={index} as="span" size="sm">
                {time}
              </KText>
            );
          default:
            return part;
        }
      }
      return (
        <KText key={index} as="span" size="sm">
          {part}
        </KText>
      );
    });
  };

  return <KText>{renderMessage()}</KText>;
};
